/* eslint-disable no-param-reassign */
/* eslint-disable react/no-unescaped-entities */
import { ArrowLeftOutlined, CloudUploadOutlined, DeleteOutlined, EditOutlined, EyeOutlined, FilterOutlined, RightCircleTwoTone, DownCircleTwoTone } from '@ant-design/icons';
import {
    Button, Form,
    Input,
    Modal,
    Space,
    Table,
    Tabs,
    Tooltip,
    Typography,
    Upload, notification, DatePicker, Drawer, Select, Layout, Row, Col, Card, Checkbox,
    Radio
} from 'antd';
import { get } from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import history from '../../services/history';

import PricingForm from './PricingForm';
import PricingTable from './PricingTable';
import { AddOrUpdateConfigData, generateData360Pricing, generateFeaturePricing, getConfogListFromDatabse } from '../../redux/Pricing gudiance/saga';
import { authenticateCurrentUser } from '../../services/auth';
import FeatureLcienseTable from './FeatureLcienseTable';
import FeatureLicenseConfig from './FeatureLicenseConfig';



const { Option } = Select;
const { Title, Text } = Typography;
const { TabPane } = Tabs;
//const { TabPane } = Tabs;
//const { Column } = Table;
//const { Search } = Input;

//const { Option } = Select;
const FeatureLicensePage = (props) => {

    const {
        setFeatureConfigData, featureConfigData,setShowConfiguration,showConfiguration
    } = props;






    const [userName, setUserName] = useState('');
    const [userGroup, setUserGroup] = useState([]);







    //const [showConfiguration, setShowConfiguration] = useState(false);
    const [GenerateLoading, setGenerateLoading] = useState(false)
    const [showPricingTable, setShowPricingTable] = useState(false)
    const [ConfigData, setConfigData] = useState({})
    const [isInputfeildChanged, setIsInputfeildChanged] = useState(false)
    const M500_application_features = ["Basic", "Solid Wire", "Horizontal Tracking", 'Fronius Power Supply', 'Lincoln Power Supply']; //TIG welding removed as discussed by vinay
    const P625_application_features = ["Basic", "360 degree Welding", "Zone to Zone Ramping", "Touch ramp", 'Fronius Power Supply'];
    const [formData, setFormData] = useState(
        featureConfigData.Welding_system
    )

    const [pricingFeatureData, setPricingFeatureData] = useState(null);
    const [pricingFeatureMsg, setPricingFeatureMsg] = useState('');

    // useEffect(() => {


    //     {
    //         (async () => {


    //             const config = await getConfogListFromDatabse()
    //             console.log('confog', config)
    //             if (config && config[0] && config[0].Configuration) {
    //                 setConfigData(config[0])
    //                 setFormData(config[0].Configuration)
    //             }
    //             //setFormData(config.Configuration)
    //         })();
    //     }


    // }, [])

    /** get user Access */
    useEffect(() => {
        authenticateCurrentUser()
            .then(async (data) => {
                if (data.signInUserSession.accessToken.payload["cognito:groups"]) {

                    let response = data.signInUserSession.accessToken.payload["cognito:groups"] //await getA(data.username)
                    //const userAccess = response.map(item => item?.GroupName)
                    //console.log(response)
                    const userEmail = JSON.parse(localStorage.getItem('user')).email
                    setUserName(userEmail);
                    setUserGroup(response);
                }
            })
            .catch((error) => {
                console.log('error', error);
            });
    }, [history]);

    const getTitle = (title) => {
        if (title == 'Lincoln Power Supply')
            return 'Lincoln PS'
        else if (title == 'Fronius Power Supply')
            return 'Fronius TPSi'
        else if (title == 'Zone to Zone Ramping')
            return 'Zone Ramping'
        else if (title == 'Zone to Zone Ramping')
            return 'Zone Ramping'
        else if (title == 'Touch ramp')
            return 'Touch'
        else
            return title
    }



    const formatCurrency = (value) => {
        return value
            ? `$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            : '$0.00';
    };

    const onGenerateFeaturePricing = async () => {
        setGenerateLoading(true)
        if (featureConfigData) {

        
            featureConfigData['Welding_system'] = formData
            console.log('Inputs Data', featureConfigData)
            const res = await generateFeaturePricing(featureConfigData)
           // console.log('Inputs Data', res)
            if (res && res.length > 0) {

           
               // console.log(message);
                const data = res.filter(item => item.License != 'Basic')


                const totalLicPrice = data.reduce((sum, item) => sum + (item.Total_lic_price || 0), 0); // Handle undefined values safely

                const margin = featureConfigData.Recovery_details.margin; 
                
                //const message = `Total License Price: ${formatCurrency(totalLicPrice)} | Margin: ${margin}%`;

                const message = `Price for selected feature licenses is ${formatCurrency(totalLicPrice)} at a margin of ${margin *100}%`;
                setPricingFeatureMsg(message)
                if (data.length > 0)
                    setPricingFeatureData(data)
                setShowPricingTable(true)
            }
        }


        setGenerateLoading(false)
    }

    const handleInputChange = (category, type, value) => {
        //setIsInputfeildChanged(true)
        //const category = 'Power_Supplies'
       // setShowPricingTable(false)
        setIsInputfeildChanged(true)
        setFormData((prevOptions) => {
            const updatedCategory = { ...prevOptions[category] };
            updatedCategory[type] = value;


            return {
                ...prevOptions,
                [category]: updatedCategory,
            };
        });
    }


    const getCategoryValue1 = (category, type) => {
        if (formData.hasOwnProperty(category)) { // Check if the category exists in selectedOptions
            return formData[category][type]; // Return the value for the category
        }
    };



    const onValuesChange = (changedValues, allValues) => {

        setIsInputfeildChanged(true)
    };
    const WeldingSystemUI = () => {
        // const [formData, setFormData] = useState({});

        const handleCheckboxChange = (category, feature, checked) => {
            setFormData((prev) => ({
                ...prev,
                [category]: {
                    ...prev[category],
                    [feature]: { ...prev[category]?.[feature], Selected: checked ? "Yes" : "No" }
                }
            }));
           // setShowPricingTable(false)
        };
        const handleQuantityChange = (category, feature, value) => {
            setFormData((prev) => ({
                ...prev,
                [category]: {
                    ...prev[category],
                    [feature]: { ...prev[category]?.[feature], Quantity: value }
                }
            }));
           // setShowPricingTable(false)
        };

        const handleInputChange = (category, feature, value) => {
            setFormData((prev) => ({
                ...prev,
                [category]: {
                    ...prev[category],
                    [feature]: { ...prev[category]?.[feature], Duration: value }
                }
            }));
           // setShowPricingTable(false)
        };

        return (
            <Row gutter={24}>
                {["M-500", "P-625"].map((category) => (
                    <Col span={12} key={category}>
                        <Card
                            scroll={{ y: 'calc(100vh - 400px)' }}
                            className='Cashflow-custom-card'
                            // style={{ height: "calc(100vh - 650px)", fontSize: '20px' }}
                            style={{ overflowY: "auto", overflowX: "hidden" }}
                            headStyle={{ alignItems: 'left', display: 'flow', justifyContent: 'space-between', width: '100%', paddingTop: '10px' }}
                            title={
                                <div className='' style={{ position: 'relative', display: 'flex', width: '100%' }}>


                                    <span style={{ marginLeft: '0px' }}>{category}</span>

                                </div>
                            }
                        >
                            {(category === "M-500" ? M500_application_features : P625_application_features).map(
                                (feature) => (

                                    <Row gutter={12} style={{ paddingTop: '5px' }}>
                                        <Col span={8} style={{ textAlign: 'left', }} >
                                            <Checkbox
                                                checked={formData[category]?.[feature]?.Selected === "Yes"}
                                                onChange={(e) => handleCheckboxChange(category, feature, e.target.checked)}
                                                style={{ paddingTop: "10px", alignContent: 'flex-start' }}
                                                disabled={feature === 'Basic'}
                                            >
                                                {getTitle(feature)}
                                            </Checkbox>
                                        </Col>

                                        {formData[category]?.[feature]?.Selected === "Yes" && (
                                            <>
                                                <Col span={8} >
                                                    <Select
                                                        className="bevel-select"
                                                        value={formData[category]?.[feature]?.Duration || null}
                                                        onChange={(value) => handleInputChange(category, feature, value)}
                                                        showSearch
                                                        allowClear
                                                        placeholder="Select Duration"
                                                        style={{ textAlign: "left", }}
                                                        disabled={feature === 'Basic'}
                                                    >
                                                        {['1 Year', '2 Year', '3 Year', '5 Year', 'Perpetual'].map((item, i) => (
                                                            <Option key={i} value={item}>{item}</Option>
                                                        ))}
                                                    </Select>
                                                </Col>
                                                <Col span={8} >
                                                    <Input
                                                        type="number"
                                                        min={1}
                                                        max={100}
                                                        placeholder="Enter Quantity"
                                                        value={formData[category]?.[feature]?.Quantity || ""}
                                                        onChange={(e) => handleQuantityChange(category, feature, Number(e.target.value))}
                                                        style={{ borderRadius: "5px" }}
                                                    />
                                                </Col>
                                            </>
                                        )}
                                    </Row>

                                )
                            )}
                        </Card>
                    </Col>
                ))}
            </Row>
        );
    };

    const getPricingTabpanes = () => {
        return (
            <div className="custom-tab h-100" style={{ paddingTop: '0px' }}>

                <div className="flex-auto">
                    {WeldingSystemUI()}
                </div>




            </div>
        );
    }



    return (

        <div className="d-flex flex-column h-100">


            {!showConfiguration && <div>


                <div className="d-flex mb-2 align-items-center tab-content-title">
                    <div className="new-calibration">
                        {userGroup && userGroup.includes('pricing-gudiance-admin') &&

                            <Button shape="round" key="apply" type="primary" style={{ marginTop: '0px' }}
                                onClick={() => setShowConfiguration(true)} >
                                Configuration
                            </Button>

                        }
                    </div>
                </div>
                {getPricingTabpanes()}

                <div>

                    <Button shape="round" key="apply" type="primary" style={{ marginTop: '10px' }}
                        onClick={() => onGenerateFeaturePricing()} loading={GenerateLoading}
                    >
                        Generate Pricing
                    </Button>
                    {pricingFeatureData && showPricingTable &&
                        <div>
                            <div style={{ fontSize: '24px', color: 'green', paddingTop: '10px', fontWeight: 'bold' }}>
                                {pricingFeatureMsg ?? ''}
                            </div>

                            <FeatureLcienseTable
                                pricingFeatureData={pricingFeatureData}
                                formData={formData}

                            ></FeatureLcienseTable>
                        </div>
                    }

                </div>
            </div>
            }


            {/* {showConfiguration &&
                <FeatureLicenseConfig
                    setConfigData={setConfigData}
                    ConfigData={ConfigData}
                    setFormData={setFeatureConfigData}
                    formData={featureConfigData}
                    showConfiguration={showConfiguration}
                  //  Contractor={Contractor}
                    setShowConfiguration={setShowConfiguration}
                >

                </FeatureLicenseConfig>
            } */}
        </div>
    );
};
const mapStateToProps = ({ }) => {
    // const projectList = get(PricingListReducer, 'PricingList', []);

    // const isLoading = get(PricingListReducer, 'isFetchLoading', false);
    // const listCount = get(PricingListReducer, 'PricingListCount', null);
    // const listTotalCount = get(PricingListReducer, 'PricingListTotalCount', null);

    return {
        // projectList,
        // isLoading,
        // listCount,
        // listTotalCount
    }
}

const mapDispatchToProps = {

    // onPricingList: fetchPricingdList,
}


export default connect(mapStateToProps, mapDispatchToProps)(FeatureLicensePage);

